import type { ColorToken, TaskDTO, TaskType } from '@hearth/shared';
import { Bell, CalendarClock, type LucideIcon, Mail, Phone, SquareCheckBig, StickyNote, Users } from 'lucide-react';

/** Default calendar color per entry type; an entry's own `color` overrides it. */
export const TASK_TYPE_COLORS: Record<TaskType, ColorToken> = {
  follow_up: 'sky',
  call: 'emerald',
  email: 'indigo',
  meeting: 'violet',
  reminder: 'amber',
  todo: 'slate',
  note: 'yellow',
};

export const TASK_TYPE_ICONS: Record<TaskType, LucideIcon> = {
  follow_up: CalendarClock,
  call: Phone,
  email: Mail,
  meeting: Users,
  reminder: Bell,
  todo: SquareCheckBig,
  note: StickyNote,
};

/** The color an entry is drawn with. */
export function taskColor(task: Pick<TaskDTO, 'color' | 'type'>): ColorToken {
  return task.color ?? TASK_TYPE_COLORS[task.type];
}
